import axios from 'axios';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { BASE_URL3 } from '../../config/axios';
import { ToastContainer, toast } from "react-toastify";
import { AddwithWhiteCircle, DeleteDustbin, Road, SearchBig, Tires, Truckbody, UpdatePencil } from '../../components/AllSvg';
import { handleErrorToast } from '../../components/CustomFunctions';
import { Modal } from 'react-bootstrap';

import { Briefcase, X, Save, Loader, AlertCircle, SectionIcon, Trash2, AlertTriangle, Search } from "lucide-react";
import { AddModalButton, DeleteModalButton, UpdateModalButton } from '../../components/DynamicButtons';
import './worktype.css';
const WorktypeCU = ({ getData, usedFor, i }) => {
    const initialForm = {
        title: '',
        company_id: '08d19069-5ffe-4a44-ad34-405ad7633954',
    };

    const [formData, setFormData] = useState(initialForm);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const isAdd = usedFor === "Add";

    const handleShow = () => {
        setShow(true);
        if (!isAdd) setFormData(i);
    };

    const handleClose = () => {
        setShow(false);
        setFormData(initialForm);
        setErrors({});
        setInputState({});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.title || formData.title.trim() === "") {
            newErrors.title = "WorkType name is required!";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState((prev) => ({ ...prev, [name]: value }));
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (value.trim()) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const res = isAdd
                ? await axios.post(`${BASE_URL3}/project/worktype/`, formData)
                : await axios.put(`${BASE_URL3}/project/worktype/${i.id}/`, formData);

            if (res.status === 200 || res.status === 201) {
                getData();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success(`WorkType Data ${isAdd ? "Added" : "Updated"} successfully!`);
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>

            {isAdd ? (
                <AddModalButton onClick={handleShow} title="Add WorkType" />
            ) : (
                <UpdateModalButton onClick={handleShow} title="Update Worktype" />

            )
            }
            {/* <button className={isAdd ? 'upload-svg' : 'model-edit-button-new'} onClick={handleShow}>
                {isAdd ? (
                    <>
                        <AddwithWhiteCircle /> {"Worktype Name"}
                    </>
                ) : (
                    <UpdatePencil />
                )}
            </button> */}

            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal">
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div className="header-icon-wrapper">
                            <Briefcase size={24} />
                        </div>
                        <div>
                            <Modal.Title>{isAdd ? "Add" : "Update"} WorkType</Modal.Title>
                            <p className="header-subtitle">
                                {isAdd
                                    ? "Fill in the details to create a new work type"
                                    : "Edit the details of this work type"}
                            </p>
                        </div>
                    </div>
                    <button type="button" className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body">
                    <form onSubmit={handleSubmit} className="project-form">
                        <div className="form-section animate-fade-in">
                            <div className="section-title">
                                <SectionIcon icon={Briefcase} color="#8b5cf6" />
                                <div>
                                    <h4>WorkType Information</h4>
                                    <p className="section-subtitle">Name of the work type</p>
                                </div>
                            </div>

                            <div className="form-grid">
                                <div className="form-field full-width">
                                    <label>
                                        <Briefcase size={14} /> WorkType Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        placeholder="e.g. Structural Audit"
                                        onChange={handleInputChange}
                                        className={errors.title ? 'error' : inputState.title ? 'success' : ''}
                                    />
                                    {errors.title && (
                                        <span className="error-message">
                                            <AlertCircle size={12} /> {errors.title}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>

                <Modal.Footer className="modern-modal-footer">
                    <div></div>
                    <div className="submit-buttons">
                        <button type="button" className="btn-secondaryy" onClick={handleClose}>
                            Cancel
                        </button>
                        <button type="button" className="btn-primaryy" disabled={loading} onClick={handleSubmit}>
                            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                            <span>
                                {loading
                                    ? (isAdd ? 'Creating...' : 'Updating...')
                                    : (isAdd ? 'Create WorkType' : 'Update WorkType')}
                            </span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

// const WorktypeCU = ({ getData, usedFor, i }) => {
//     const [formData, setFormData] = useState({
//         title: '',
//         company_id: '08d19069-5ffe-4a44-ad34-405ad7633954',
//     });

//     const [isSubmitted, setIsSubmitted] = useState(false);

//     const [show, setShow] = useState(false);

//     const handleShow = () => {

//         setShow(true);
//         if (usedFor === "Update") {
//             setFormData(i);
//         }
//     }

//     const handleClose = () => {
//         setShow(false);

//         setFormData({
//             title: '',
//             company_id: "08d19069-5ffe-4a44-ad34-405ad7633954"
//         })
//         setErrors({});
//     }

//     const [errors, setErrors] = useState({});

//     const [inputState, setInputState] = useState({});

//     const validateForm = () => {
//         const newErrors = {};

//         if (!formData.title || formData.title.trim() === "") {
//             newErrors.title = "WorkType name is a required field.";
//         }

//         setErrors(newErrors);
//         setIsSubmitted(true);

//         return Object.keys(newErrors).length === 0;
//     };



//     const [loading, setLoading] = useState(false); //loading logic

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {

//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
//             setLoading(true); //loading logic
//             try {

//                 const url = usedFor === "Add" ? await axios.post(`${BASE_URL3}/project/worktype/`, formData) : await axios.put(`${BASE_URL3}/project/worktype/${i.id}/`, formData)

//                 let res = url

//                 if (res.status === usedFor === "Add" ? "201" : "200") {
//                     getData();
//                     handleClose();
//                     toast.dismiss(loadingToastId);
//                     toast.success(`WorkType Data ${usedFor === "Add" ? "Added" : "Updated"} successfully!`);

//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 handleErrorToast(err)
//             } finally {
//                 setLoading(false); //loading logic
//                 toast.dismiss(loadingToastId);
//             }

//         }
//     };





//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         setInputState({
//             ...inputState,
//             [name]: value,
//         });

//         setFormData({
//             ...formData,
//             [name]: value,
//         });
//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };



//     return (
//         <>
//             <button className={usedFor === "Add" ? 'upload-svg' : 'model-edit-button-new'} onClick={handleShow}>
//                 {usedFor === "Add" ?
//                     <>
//                         <AddwithWhiteCircle /> {"Worktype Name"}
//                     </>
//                     : <UpdatePencil />
//                 }
//             </button>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
//                 <Modal.Header closeButton>
//                     <Modal.Title>{usedFor === "Add" ? "Add" : "Update"} WorkType Name</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <form>
//                             <div className='form-flex-wrap' style={{ justifyContent: "space-between" }}>

//                                 <div className="flex-column ">
//                                     <label className="form-labels">WorkType Name:<span className="required">*</span></label>
//                                     <input
//                                         type="text"
//                                         name="title"
//                                         value={formData.title}
//                                         placeholder="WorkType Name"
//                                         onChange={handleInputChange}
//                                         className={`form-input width-15vw ${errors.title ? 'error' : inputState.title ? 'success' : ''}`}
//                                         style={{ width: "18vw" }}
//                                     />
//                                     {errors.title && <span className="error-message">{errors.title}</span>}
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                 </Modal.Body>
//                 <div className="button-models-gap-116 " style={{ marginBottom: "20px" }} >
//                     <div className="">
//                         <button type="button" onClick={handleClose} className="model-button-cancel model-button   font-weight500  ">Cancel</button>
//                     </div>

//                     <div className="">
//                         <button onClick={handleSubmit} className="model-button model-button-submit">{usedFor === "Add" ? "Submit" : "Update"}</button>
//                     </div>

//                 </div>
//             </Modal>
//         </>
//     );
// };

const DeleteWorkType = ({ i, getData }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const res = await axios.delete(`${BASE_URL3}/project/worktype/${i.id}/`);

            if (res.status === 200 || res.status === 204) {
                await getData();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <DeleteModalButton title="Delete Data" onClick={handleShow} />


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="modern-project-modal"
                size="md"
                centered
            >
                {/* ===== HEADER ===== */}
                <Modal.Header className="modern-modal-header delete-modal-header">
                    <div className="header-content">
                        <div className="header-icon-wrapper delete-icon-wrapper">
                            <Trash2 size={22} />
                        </div>
                        <div>
                            <Modal.Title>Delete WorkType</Modal.Title>
                            <p className="header-subtitle">This action cannot be undone</p>
                        </div>
                    </div>
                    <button type="button" className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                {/* ===== BODY ===== */}
                <Modal.Body className="modern-modal-body">
                    <div className="delete-confirm-wrap">
                        <div className="delete-warning-icon">
                            <AlertTriangle size={34} />
                        </div>

                        <h4 className="delete-confirm-title">
                            Are you sure you want to delete this WorkType?
                        </h4>
                        <p className="delete-confirm-subtitle">
                            This WorkType will be permanently removed from the system.
                        </p>

                        {/* WorkType Preview Card */}
                        {i?.title && (
                            <div className="delete-preview-card">
                                <div className="delete-preview-icon">
                                    <Briefcase size={16} />
                                </div>
                                <div className="delete-preview-content">
                                    <div className="delete-preview-name">
                                        <span>{i.title}</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="delete-warning-note">
                            <AlertCircle size={14} />
                            <span>This will permanently delete the WorkType.</span>
                        </div>
                    </div>
                </Modal.Body>

                {/* ===== FOOTER ===== */}
                <Modal.Footer className="modern-modal-footer">
                    <button
                        type="button"
                        className="btn-secondaryy"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleFormSubmitDelete}
                        className="btn-danger-delete"
                        disabled={loading}
                    >
                        {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                        <span>{loading ? 'Deleting...' : 'Delete WorkType'}</span>
                    </button>
                </Modal.Footer>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};
// const DeleteWorkType = ({ i, getData }) => {
//     const [show, setShow] = useState(false);

//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         setShow(true);
//     };

//     const handleFormSubmitDelete = async (e) => {
//         e.preventDefault();
//         const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//         try {
//             let res = await axios.delete(
//                 `${BASE_URL3}/project/worktype/${i.id}/`
//             );

//             if (res.status === 200) {
//                 await getData();
//                 setShow(false);
//                 toast.dismiss(loadingToastId);
//                 toast.success("Data deleted successfully");
//             } else {
//                 alert(res);
//             }
//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {
//             toast.dismiss(loadingToastId);
//         }
//     };

//     return (
//         <>
//             <button
//                 title="Delete WorkType"
//                 className="model-delete-button"
//                 onClick={handleShow}
//             >
//                 <DeleteDustbin />
//             </button>

//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="request-leave width-40vw"
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Delete WorkType of "{i.title}"</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         Are You Sure You Want to delete WorkType ?
//                         <div className="button-models">
//                             <button
//                                 className="model-button   font-weight500    model-button-cancel "
//                                 onClick={handleClose}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleFormSubmitDelete}
//                                 className="model-button   font-weight500    model-button-delete"
//                             >
//                                 Delete
//                             </button>
//                         </div>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };



const WorkType = ({ worktypeName, buffer, getData }) => {
    const [searchQuery, setSearchQuery] = useState("");

    const filteredList = (worktypeName || [])
        .filter((e) => e.title?.toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) =>
            a.title?.localeCompare(b.title, "en", { ignorePunctuation: true })
        );

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="wt-page">
                <div className="wt-card">
                    {/* ===== HEADER ===== */}
                    <div className="wt-header">
                        <div className="wt-header-left">
                            <div className="wt-header-icon">
                                <Briefcase size={20} />
                            </div>
                            <div>
                                <h4 className="wt-title">
                                    WorkTypes
                                    <span className="wt-count">{filteredList.length}</span>
                                </h4>
                                <p className="wt-subtitle">Manage the work types used in quotations</p>
                            </div>
                        </div>

                        <div className="wt-header-right">
                            <div className="wt-search">
                                <Search size={16} />
                                <input
                                    type="text"
                                    placeholder="Search work type..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                {searchQuery && (
                                    <button
                                        type="button"
                                        className="wt-search-clear"
                                        onClick={() => setSearchQuery("")}
                                        title="Clear"
                                    >
                                        <X size={14} />
                                    </button>
                                )}
                            </div>
                            <WorktypeCU getData={getData} usedFor="Add" />
                        </div>
                    </div>

                    {/* ===== TABLE ===== */}
                    <div className="wt-table-wrap">
                        <table className="wt-table">
                            <thead>
                                <tr>
                                    <th style={{ width: 140 }}>S.No.</th>
                                    <th style={{ textAlign: "center" }}>WorkType Name</th>
                                    <th style={{ width: 140 }} className="wt-th-end">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {buffer ? (
                                    <tr>
                                        <td colSpan={4}>
                                            <div className="wt-state">
                                                <div className="spinner-bgdatil"></div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : filteredList.length === 0 ? (
                                    <tr>
                                        <td colSpan={4}>
                                            <div className="wt-state">
                                                <Briefcase size={30} />
                                                <p>{searchQuery ? "No matching work types" : "No work types added yet"}</p>
                                                <small>
                                                    {searchQuery
                                                        ? "Try a different search term"
                                                        : "Click the add button to create your first work type"}
                                                </small>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredList.map((i, index) => (
                                        <tr key={i.id || index}>
                                            <td className="wt-sno">{index + 1}.</td>
                                            {/* <td>{i.company?.title || "-"}</td> */}
                                            <td className="wt-name" style={{ textAlign: "center" }}>{i.title}</td>
                                            <td>
                                                <div className="wt-actions">
                                                    <WorktypeCU usedFor="Update" i={i} getData={getData} />
                                                    <DeleteWorkType i={i} getData={getData} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};


// const WorkType = ({ worktypeName, buffer, getData }) => {

//     const [searchQuery, setSearchQuery] = useState("");


//     return (
//         <>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <div >
//                 <div className="attendance-box">
//                     <div className="datagrid-container">
//                         <div className="custom-table-background" style={{ height: "66vh" }}>
//                             <div className="">
//                                 <div className="">
//                                     <div className="table-box ">
//                                         <div className="flex-row table-heading" style={{ justifyContent: "end" }}>

//                                             <WorktypeCU getData={getData} usedFor="Add" />
//                                         </div>
//                                     </div>
//                                     <div className='table-box scroll-container-table'
//                                     >
//                                         <table className="table-css width-100vw">
//                                             <thead className="table-heading">
//                                                 <tr className="custom-table-head-tr">
//                                                     <th className="table-heading ">S.no.</th>
//                                                     <th className="table-heading text-left">Company Name</th>
//                                                     <th className="table-heading text-left">WorkType Name</th>
//                                                     <th className="table-heading text-end">Action</th>
//                                                 </tr>
//                                             </thead>
//                                             {buffer ? (

//                                                 <div className="spinner-bgdatil"></div>

//                                             ) :
//                                                 <tbody>
//                                                     {
//                                                         worktypeName
//                                                             ?.filter((e) =>
//                                                                 e.title?.toLowerCase().includes(searchQuery.toLowerCase())
//                                                             )
//                                                             .sort((a, b) =>
//                                                                 a.title?.localeCompare(b.title, "en", { ignorePunctuation: true })
//                                                             )
//                                                             .map((i, index) => (
//                                                                 <tr key={index} className="custom-table-head-td">
//                                                                     <td className="table-body ">{index + 1}.</td>
//                                                                     <td className="table-body text-left">{i.company?.title}</td>
//                                                                     <td className="table-body text-left">{i.title}</td>
//                                                                     <td className="table-body justify-end flex-row">
//                                                                         <WorktypeCU usedFor="Update" i={i} getData={getData} />
//                                                                         <DeleteWorkType i={i} getData={getData} />
//                                                                     </td>
//                                                                 </tr>
//                                                             ))
//                                                     }
//                                                 </tbody>
//                                             }
//                                         </table>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

export default WorkType;